import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cpgSourceSummarySchema } from './cpg-registry.contract'

/** The per-source header strip of the Documents view; a handful of rows, unpaged. */
export const listCpgSources = oc
  .route({ method: 'GET', path: '/v2/cpg/sources' })
  .input(z.object({}).optional())
  .output(z.object({ data: z.array(cpgSourceSummarySchema) }))
